import ReactModal from 'react-modal'
import PropTypes from 'prop-types'
import cn from 'classnames'

const Dialog = ({
  isOpen,
  onDialogClose,
  children,
  classNames = '',
}) => {
  return (
    <ReactModal
      className={cn('dialog', classNames)}
      isOpen={isOpen}
      onDialogClose={onDialogClose}
      overlayClassName="dialog-overlay"
    >
      {children}
    </ReactModal>
  )
}

Dialog.propTypes = {
  isOpen: PropTypes.bool,
  onDialogClose: PropTypes.func,
  children: PropTypes.node,
}

export default Dialog
